@if (menu?.children) {
    <div appCollapse [shouldBeExpanded]="true">
        <div class="position-relative">
            <span class="collapse-header" [ngClass]="{ 'ms-3': menu.level === 1 }">
                <span class="add-arrow"></span>
            </span>

            <a
                class="block__item"
                [routerLink]="menu.routerLink"
                routerLinkActive="active-link"
                [routerLinkActiveOptions]="{ exact: true }">
                <span class="block__icon" [ngClass]="menu.icon"></span>
                <span class="block__text">{{ menu.title | translate | truncate: 40 }}</span>
            </a>
        </div>

        <div class="channels collapse-body">
            @for (subItem of menu.children; track subItem) {
                <app-left-menu-block [menu]="subItem"></app-left-menu-block>
            }
        </div>
    </div>
}

@if (menu && !menu.children) {
    @if (!menu.isExternalLink) {
        <a
            class="block__item"
            [routerLink]="menu.routerLink"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: false }">
            <span class="block__icon" [ngClass]="menu.icon" [class.ms-4]="menu.level === 2"></span>
            <span class="block__text">{{ menu.title | translate | truncate: 40 }}</span>
        </a>
    } @else {
        <a
            class="block__item justify-content-between"
            [href]="menu.routerLink"
            target="_blank"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: false }">
            <span>
                <span class="block__icon" [ngClass]="menu.icon" [class.ms-4]="menu.level === 2"></span>
                <span class="block__text">{{ menu.title | translate | truncate: 40 }}</span>
            </span>
            <sb-inline-svg class="icon align-self-start" [url]="'/sb-tools/theme/images/icons/external-link-icon.svg'">
            </sb-inline-svg>
        </a>
    }
}
